const KeepSeparateSvg = ({ active }) => {
    return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
                d="M2 13.111H4.22222V10.8888H2V13.111ZM2 17.5554H4.22222V15.3332H2V17.5554ZM2 8.66656H4.22222V6.44434H2V8.66656ZM6.44444 13.111H22V10.8888H6.44444V13.111ZM6.44444 17.5554H22V15.3332H6.44444V17.5554ZM6.44444 6.44434V8.66656H22V6.44434H6.44444Z"
                fill={active ? 'white' : '#212121'}
            />
        </svg>
    );
};

export default KeepSeparateSvg;
